import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, Tabs, Tab } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchInvoice,
  selectId,
  selectLoading,
} from "./orderSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  showDialog,
  checkEmptyFields,
  validatePrice,
  paramsMasterAll,
  setOptionsMaster,
  formatCurrency,
  formatQuantity,
  formatterStatus,
  formatDate,
  columnsOrderHidden,
  columnsOrder,
  columnsReturn,
  columnsReturnHidden,
  columnsPaymentHidden,
  columnsPayment,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import {
  FaAngleDoubleDown,
  FaAngleDoubleUp,
  FaAngleDown,
  FaAngleUp,
} from "react-icons/fa";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { fetchUom, selectUom } from "../uom/uomSlice";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { NavLink } from "react-router-dom";
const { SearchBar } = Search;

export const OrderCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const { id } = useParams();

  const [tableData, setTableData] = useState([]);
  const [tableDataReturn, setTableDataReturn] = useState([]);
  const [tableDataPayment, setTableDataPayment] = useState([]);

  const paramsId = {
    visit_order_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      const initData = dataId?.visit_order_details?.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          bonus_items: JSON.parse(item.bonus_items),
        };
      });
      setTableData(initData);
      const initData2 = dataId?.visit_returs?.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });
      setTableDataReturn(initData2);
      const initData3 = dataId?.visit_payments?.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });
      setTableDataPayment(initData3);
    }
  }, [dataId]);

  const expandRow = {
    expandByColumnOnly: true,
    showExpandColumn: true,
    renderer: (row) => (
      <BootstrapTable
        keyField="product_code"
        data={
          !row.bonus_items || row.bonus_items.length === 0
            ? []
            : row.bonus_items
        }
        columns={columnsDetail}
      />
    ),
    expandColumnRenderer: ({ expanded, rowKey, expandable }) =>
      expandable ? expanded ? <FaAngleUp /> : <FaAngleDown /> : null,

    expandHeaderColumnRenderer: ({ isAnyExpands }) =>
      isAnyExpands ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />,
    align: "center",
    nonExpandable: tableData
      .filter((row) => !row.bonus_items || row.bonus_items.length === 0)
      .map((row) => row.no),
  };

  const columnsDetail = [
    {
      text: " bonus product",
      dataField: "product_code",
      style: { maxWidth: "120px" },
      formatter: (cell, row) => (
        <div>
          <span>
            <b>{row.product_code}</b>
          </span>
          <br />
          <span>{row.product_name}</span>
        </div>
      ),
    },
    {
      text: "Uom",
      dataField: "uom_description",
      style: { maxWidth: "60px" },
    },
    {
      text: "bonus qty",
      dataField: "bonus_quantity",
      style: { maxWidth: "120px" },
      formatter: formatQuantity,
      align: "right",
    },
  ];

  const [dataViewer, setDataViewer] = useState([]);
  const [showViewer, setShowViewer] = useState(false);

  const handleShowViewer = () => setShowViewer(true);

  const handleCloseViewer = () => {
    setDataViewer([]);
    setShowViewer(false);
  };
  const handleInvoice = async () => {
    const params = {
      order_no: dataId?.order_no,
    };
    try {
      const response = await dispatch(fetchInvoice(params));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${dataId.order_no}.pdf`;
        link.click();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create Product" : "Detail Order"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            <Button
              className="btn btn-outline-danger mr-3"
              onClick={() => handleInvoice()}
            >
              Invoice
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="invoice-container">
            <h1>Order Summary : {dataId?.order_no}</h1>
            <hr />
            <div className="invoice-content">
              <div className="invoice-col">
                <div className="invoice-row">
                  <span>Ref Order No:</span>
                  <span>
                    <b> {dataId?.ref_order_no}</b>
                  </span>
                </div>
                <div className="invoice-row">
                  <span>Sales Person:</span>
                  <span>
                    {dataId?.sales_person_code} - {dataId?.sales_person_name}
                  </span>
                </div>
                <div className="invoice-row">
                  <span>Order Date:</span>
                  <span>{formatDate(dataId?.order_date)}</span>
                </div>
                <div className="invoice-row">
                  <span>Order Due Date:</span>
                  <span>{formatDate(dataId?.order_due_date) || "-"}</span>
                </div>
                <div className="invoice-row">
                  <span>Customer Store Name:</span>
                  <span>
                    <NavLink
                      className="menu-link"
                      to={`/master/customer/edit/${dataId?.customer_id}`}
                    >
                      {dataId?.customer_store_name}
                    </NavLink>
                  </span>
                </div>
                <div className="invoice-row">
                  <span>Order Type:</span>
                  <span>{dataId?.order_type}</span>
                </div>
                <div className="invoice-row">
                  <span>Delivery Address :</span>
                  <span>{dataId?.delivery_address}</span>
                </div>
              </div>
              <div className="invoice-col">
                <div className="invoice-section">
                  <div className="invoice-row">
                    <span>Status:</span>
                    <span>{formatterStatus(dataId?.status)}</span>
                  </div>
                  <div className="invoice-row">
                    <span>Total Amount:</span>
                    <span>{formatCurrency(dataId?.order_total)}</span>
                  </div>
                  <div className="invoice-row">
                    <span>Return Amount:</span>
                    <span style={{ color: "red" }}>
                      {formatCurrency(dataId?.order_retur)}
                    </span>
                  </div>
                  <div className="invoice-row">
                    <span>Discount Amount:</span>
                    <span>{formatCurrency(dataId?.discount_amount)}</span>
                  </div>
                  <div className="invoice-row">
                    <span>Final Amount:</span>
                    <span
                      style={{
                        color: dataId?.order_final < 0 ? "red" : "black",
                      }}
                    >
                      {formatCurrency(dataId?.order_final)}
                    </span>
                  </div>
                  <div className="invoice-row">
                    <span>Sum Paid:</span>
                    <span>{formatCurrency(dataId?.order_sum_paid)}</span>
                  </div>
                  <div className="invoice-row">
                    <span>Remaining Amount:</span>
                    <span style={{ color: "red" }}>
                      {formatCurrency(dataId?.order_remain)}
                    </span>
                  </div>

                  <div className="invoice-row">
                    <span>Payment Type:</span>
                    <span>{dataId?.customer_payment_type}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Tabs
            defaultActiveKey="Order"
            id="uncontrolled-tab-example"
            className="nav nav-tabs nav-tabs-line mb-5"
          >
            <Tab eventKey="Order" title="Order">
              <div
                className="card-body pt-0"
                style={{
                  overflowY: "scroll",
                }}
              >
                <ToolkitProvider
                  keyField="no"
                  data={tableData}
                  columns={
                    tableData.length > 0 ? columnsOrder : columnsOrderHidden
                  }
                  search
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container">
                        <BootstrapTable
                          // wrapperClasses="table-responsive"
                          striped
                          noDataIndication="Data Not Found"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                          expandRow={expandRow}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </Tab>
            <Tab eventKey="Return" title="Return">
              <div
                className="card-body pt-0"
                style={{
                  overflowY: "scroll",
                }}
              >
                <ToolkitProvider
                  keyField="no"
                  data={tableDataReturn}
                  columns={
                    tableDataReturn.length > 0
                      ? columnsReturn
                      : columnsReturnHidden
                  }
                  search
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container">
                        <BootstrapTable
                          // wrapperClasses="table-responsive"
                          striped
                          noDataIndication="Data Not Found"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </Tab>
            <Tab eventKey="Payment" title="Payment">
              <div
                className="card-body pt-0"
                style={{
                  overflowY: "scroll",
                }}
              >
                <ToolkitProvider
                  keyField="no"
                  data={tableDataPayment}
                  columns={
                    tableDataPayment.length > 0
                      ? columnsPaymentHidden
                      : columnsPaymentHidden
                  }
                  search
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container">
                        <BootstrapTable
                          // wrapperClasses="table-responsive"
                          striped
                          noDataIndication="Data Not Found"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </Tab>
          </Tabs>
        </CardBody>
      </Card>

      {/* <AttachmentViewer
        data={dataViewer}
        handleClose={handleCloseViewer}
        show={showViewer}
      /> */}
    </>
  );
};
